import { computed } from 'vue'
import webapp from '@/services/webapp'

export const useFullScreenDimensions = () => {
  const topNumber = computed(() => Math.max(40, webapp.safeAreaInset.top + webapp.contentSafeAreaInset.top))
  const bottomNumber = computed(() => Math.max(40, webapp.safeAreaInset.bottom + webapp.contentSafeAreaInset.bottom))

  const topStyle = computed(() => {
    return { top: `${topNumber.value}px` }
  })

  return {
    topStyle,
    topNumber,
    bottomNumber,
  }
}